<script setup>
const columns = [
    {
        title: 'Co děláme jinak',
        subtitle: 'Papír i online.',
        description:
            'Digitálně pro rychlost, papírově pro klid. Nenutíme vás do šablon, které vám nesedí. Startupy a nadšence potěší plně digitální přístup přes aplikaci z mobilu, tradicionalistům rádi přebereme klasické papírové složky. Způsob je čistě na vás, přizpůsobíme se vašemu tempu.',
    },
    {
        title: 'Naše hodnoty',
        subtitle: 'Lidskost a otevřenost.',
        description:
            'Účetnictví dělají lidé pro lidi. Nejsme jen externí služba, která jednou za rok pošle přiznání. Chceme znát váš příběh a rozumět vašemu podnikání. Jsme tu od toho, abychom vám kryli záda a pomáhali dělat správná rozhodnutí.',
    },
]
</script>

<template>
    <section class="bg-white pt-4 pb-20 md:pt-8 md:pb-28">
        <div class="mx-auto max-w-7xl px-6 lg:px-10">
            <div class="grid gap-14 md:grid-cols-2 md:gap-12 lg:gap-20">
                <div
                    v-for="column in columns"
                    :key="column.title"
                >
                    <h3 class="text-brand-900 text-3xl font-extrabold tracking-tight md:text-4xl">
                        {{ column.title }}
                    </h3>

                    <p class="text-brand-700 mt-5 text-2xl font-bold tracking-tight md:text-3xl">
                        {{ column.subtitle }}
                    </p>

                    <p class="mt-6 max-w-lg text-base leading-relaxed text-zinc-600">
                        {{ column.description }}
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>
